"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Filter.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : ListFilter.js
* Description : Ce fichier contient la définition du composant ListFilter 
*               Ce composant est une liste déroulante pour réaliser un filtrage en choisisant un élément dans une liste
* Date de création : 23 septembre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */
// None

/**
* ListFilter : affiche une liste déroulante pour réaliser un filtrage en choisisant un élément dans une liste
*
* Type : composant 
*
* Parametres : 
*  - labelText -- texte affiché au dessus de la liste déroulante pour apporter des précisions
*  - choices -- liste des éléments présents dans la liste déroulante
*  - choiceParam -- paramètre à utiliser pour afficher les élements de la liste
*  - selectedItem -- élément sélectionnée
*  - setSelectedItem -- fonction pour mettre à jour la variable selectedItem
*  - subfilter -- décalage de la position de la liste déroulante si celle-ci déped du choix d'une autre liste
*/function ListFilter(_ref) {
  var labelText = _ref.labelText,
    choices = _ref.choices,
    choiceParam = _ref.choiceParam,
    selectedItem = _ref.selectedItem,
    setSelectedItem = _ref.setSelectedItem,
    subfilter = _ref.subfilter;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: subfilter === true ? 'list-subfilter' : 'list-filter',
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: "list-filter-label",
      children: [labelText, " :"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
      name: "selectedChoice",
      className: "list-filter-option",
      value: selectedItem,
      onChange: function onChange(e) {
        return setSelectedItem(e.target.value);
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: 0,
        children: '--Tous--'
      }), choices.map(function (choice) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: choice['id'],
          children: choice[choiceParam]
        }, choice['id']);
      })]
    })]
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
ListFilter.propTypes = {
  labelText: _propTypes["default"].string,
  choices: _propTypes["default"].array,
  selectedItem: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  setSelectedItem: _propTypes["default"].func
};
var _default = exports["default"] = ListFilter;